import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import ReservationDateSelect from 'ui/utils/ReservationDateSelect'
import { Button, Paper } from '@mui/material'
import Stack from 'ui/layout/Stack'
import addDays from 'date-fns/addDays'
import FutureReservationFrames from 'ui/organisms/FutureReservationFrames'
import Modal from 'ui/layout/Modal'
import MarginRightCancelButton from 'ui/shorthands/MarginRightCancelButton'
import { StackItem } from 'ui/layout/StackItem'
import ModalScrollContent from 'ui/layout/ModalScrollContent'
import { ReservationFrameUnitMin } from 'types/common'
import { jstNewDate } from 'ui/utils/jstDatetime'

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    position: 'relative',
  },
}))

export type ReservationDateModalProps = {
  open: boolean
  /** 保存済みの予約日時 */
  currentDatetime: {
    start: string
    end: string
  }
  onCancel: () => void
  onSubmit: (data: {
    reservation_datetime_start: string
    reservation_datetime_end: string
  }) => Promise<void>
  unit: ReservationFrameUnitMin
}
const ReservationDateModal: React.FC<ReservationDateModalProps> = ({
  currentDatetime,
  open,
  onCancel,
  onSubmit,
  unit,
}: ReservationDateModalProps) => {
  const { t } = useTranslation()
  const [date, setDate] = useState<Date>(jstNewDate)
  const [sending, setSending] = useState<boolean>(false)

  const [datetime, setDatetime] = useState<
    | {
        reservation_datetime_start: string
        reservation_datetime_end: string
      }
    | undefined
  >(undefined)
  const { classes } = useStyles()

  const disabled =
    sending ||
    !datetime ||
    (currentDatetime.start === datetime?.reservation_datetime_start &&
      currentDatetime.end === datetime?.reservation_datetime_end)

  return (
    <Modal large open={open} handleClose={() => onCancel()}>
      <ModalScrollContent
        footer={
          <Stack align="right" borderTop>
            <MarginRightCancelButton onClick={() => onCancel()} />
            <Button
              color="primary"
              variant="contained"
              onClick={(e) => {
                e.stopPropagation()
                setSending(true)
                return (
                  datetime &&
                  onSubmit(datetime).finally(() => setSending(false))
                )
              }}
              disabled={disabled}
            >
              {t('保存')}
            </Button>
          </Stack>
        }
      >
        <Paper className={classes.root}>
          <StackItem label={t('日時')} alignTop>
            {t(
              '日時を変更する場合、予約者の了承を事前に取ってから操作することをおすすめいたします。保存すると、変更は確定され予約者に変更完了メールが送信されます。'
            )}
          </StackItem>
          <ReservationDateSelect
            selectedDate={date}
            onSelect={setDate}
            minDate={jstNewDate}
            maxDate={addDays(jstNewDate, 12 * 7 - 1)}
          />
          <FutureReservationFrames
            unit={unit}
            date={date}
            onSelect={(data) =>
              setDatetime({
                reservation_datetime_start: data.start_datetime,
                reservation_datetime_end: data.end_datetime,
              })
            }
          />
        </Paper>
      </ModalScrollContent>
    </Modal>
  )
}

export default ReservationDateModal
